import { GetterTree } from 'vuex';
import { RootState } from './types';
import { GET_ANSWER_BY_ID } from './types'

export const getters: GetterTree<RootState, RootState> = {
    [GET_ANSWER_BY_ID]: (state) => (id) => {
        const answer: any = state.userData.userAnswers.find((a: any) => a.questionId === id);

        if (answer) {
            return answer;
        }

        return null;
    }
};
